module.exports = __webpack_public_path__ + "startpage-746fed5a/templates-preview-1x-29783a346869ea8eaa21863fe6ce50a3.png";